<script>
import Utils from '@/common/Utils';
import Listbox from 'primevue/listbox';
import Service from '@/services/demurrage';

export default {
    props: ['input', 'columns', 'x', 'labelType', 'editable', 'allColumns', 'title', 'id', 'order', 'lastYears', 'disableLastYears'],
    emits: ['onSaveSuccess'],
    data() {
        return {
            intTitle: this.title,
            compositor: false,
            barSelectedColumns: [],
            lineSelectedColumns: [],
            showPreviousYears: false
        }
    },
    created() {

        if (this.columns && this.columns.length > 0) {
            this.barSelectedColumns = this.columns.filter(x => x.columnType == 'bar').map(x => {
                return {
                    columnName: x.columnName,
                    columnLabel: x.columnLabel
                }
            });
            this.lineSelectedColumns = this.columns.filter(x => x.columnType == 'line').map(x => {
                return {
                    columnName: x.columnName,
                    columnLabel: x.columnLabel
                }
            });
        }

        if (!this.id) {
            this.compositor = true;
        }
    },
    computed: {
        cols() {
            return this.compositor ? this.selectedColumns : this.columns
        },
        selectedColumns() {
            let columns = [];
            for (let i = 0; i < this.barSelectedColumns.length; i++) {
                let c = this.barSelectedColumns[i];
                columns.push({
                    columnName: c.columnName,
                    columnLabel: c.columnLabel,
                    columnType: 'bar'
                });
            }
            for (let i = 0; i < this.lineSelectedColumns.length; i++) {
                let c = this.lineSelectedColumns[i];
                columns.push({
                    columnName: c.columnName,
                    columnLabel: c.columnLabel,
                    columnType: 'line'
                });
            }

            return columns;
        },
        data() {
            const documentStyle = getComputedStyle(document.documentElement);

            let colors = [
                'rgba(145,226,237, 0.4)',
                'rgba(251,199,145, 0.4)',
                'rgba(178,221,180, 0.4)',
                'rgba(246,158,188, 0.4)',
                'rgba(187,199,205, 0.4)',
                'rgba(212,162,221, 0.4)'
            ];

            let borderColors = [
                documentStyle.getPropertyValue('--cyan-500'),
                documentStyle.getPropertyValue('--orange-500'),
                documentStyle.getPropertyValue('--green-500'),
                documentStyle.getPropertyValue('--pink-500'),
                documentStyle.getPropertyValue('--bluegray-500'),
                documentStyle.getPropertyValue('--purple-500'),
            ]

            let labels = this.input.filter(x => x.referenceDate != '0001-01-01T00:00:00').map(i => {
                if (this.labelType == 'date') {
                    return Utils.formatDate(Utils.dateToCurrentTimeZone(i[this.x]));
                } else if (this.labelType == 'month') {
                    return Utils.formatMonthYear(Utils.dateToCurrentTimeZone(i[this.x]));
                } else {
                    return i[this.x];
                }
            });

            let datasets = [];
            let colorProgressive = 0;

            for (let i = 0; i < this.cols.length; i++) {
                let col = this.cols[i];
                let dataset = {
                    label: this.$t(col.columnLabel),
                    data: this.input.filter(x => x.referenceDate != '0001-01-01T00:00:00').map(i => i[col.columnName]),
                    borderColor: [borderColors[colorProgressive % borderColors.length]]
                }

                if (col.columnType == 'line') {
                    dataset.type = 'line';
                    dataset.fill = false;
                    dataset.tension = 0.4;
                    dataset.borderWidth = 2;
                } else if (col.columnType == 'bar') {
                    dataset.backgroundColor = [colors[colorProgressive % colors.length]];
                    dataset.borderWidth = 1;
                }

                datasets.push(dataset);
                colorProgressive++;
            }

            if (this.lastYears && this.showPreviousYears) {
                for (let y = 0; y < this.lastYears.length; y++) {
                    for (let i = 0; i < this.cols.length; i++) {
                        let col = this.cols[i];
                        let dataset = {
                            label: this.lastYears[y] + ' ' + this.$t(col.columnLabel),
                            data: this.input.filter(x => x.referenceDate != '0001-01-01T00:00:00').map(i => i?.lastYears[this.lastYears[y]]?.[col.columnName]),
                            borderColor: [borderColors[colorProgressive % borderColors.length]]
                        }

                        if (col.columnType == 'line') {
                            dataset.type = 'line';
                            dataset.fill = false;
                            dataset.tension = 0.4;
                            dataset.borderWidth = 2;
                        } else if (col.columnType == 'bar') {
                            dataset.backgroundColor = [colors[colorProgressive % colors.length]];
                            dataset.borderWidth = 1;
                        }

                        datasets.push(dataset);
                        colorProgressive++;
                    }
                }
            }

            return {
                labels: labels,
                datasets: datasets
            }
        },
        graphOptions() {
            const documentStyle = getComputedStyle(document.documentElement);
            const textColor = documentStyle.getPropertyValue('--text-color');
            const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
            const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

            return {
                plugins: {
                    legend: {
                        labels: {
                            color: textColor
                        }
                    }
                },
                scales: {
                    x: {
                        beginAtZero: true,
                        ticks: {
                            color: textColorSecondary
                        },
                        grid: {
                            color: surfaceBorder
                        }
                    },
                    y: {
                        beginAtZero: true,
                        ticks: {
                            color: textColorSecondary
                        },
                        grid: {
                            color: surfaceBorder
                        }
                    }
                }
            };
        }
    },
    methods: {
        toggleEdit() {
            this.compositor = !this.compositor
        },
        saveGraph() {

            let body = {
                label: this.x,
                labelType: this.labelType,
                deletable: true,
                title: this.intTitle,
                graphOrder: this.order,
                details: this.selectedColumns
            };

            if (this.id) {
                body.id = this.id;

                Service.updateGraph(body, response => {
                    if (response.success) {
                        this.$emit('onSaveSuccess')
                    } else {
                        this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                    }
                });
            } else {
                Service.createGraph(body, response => {
                    if (response.success) {
                        this.$emit('onSaveSuccess')
                    } else {
                        this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                    }
                });
            }

        },
        deleteGraph() {

            this.$confirm.require({
                message: this.$t('messages.delete_message_question'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {

                    Service.deleteGraph(this.id, response => {
                        if (response.success) {
                            this.$emit('onSaveSuccess')
                        } else {
                            this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                        }
                    });
                },
                reject: () => {
                    this.$confirm.close();
                },
            });


        }
    }
};
</script>

<template>
    <Card :class="{ 'col-8': !compositor, 'col-12': compositor }">
        <template #title>
            <p v-if="!compositor">{{ intTitle }}</p>
            <InputText type="text" class="w-full" v-model="intTitle" v-else />

            <div class="m-2" v-if="!disableLastYears">
                <Checkbox v-model="showPreviousYears" :binary="true" />
                <label for="showPreviousYears" class="ml-2" style="font-size: 12px;"> {{
                    $t('DemurrageStatistics.showPreviousYears') }}
                </label>
            </div>
        </template>
        <template #content>
            <div class="grid">
                <div class="col-12" v-if="editable">
                    <Button :icon="compositor ? 'pi pi-times' : 'pi pi-pencil'" rounded outlined @click="toggleEdit"
                        v-if="id" :label="compositor ? $t('btn.cancel') : $t('btn.edit')" class="m-1" />
                    <Button icon="pi pi-save" rounded outlined @click="saveGraph" :label="$t('btn.save')" class="m-1"
                        v-if="compositor" />
                    <Button icon="pi pi-trash" rounded outlined @click="deleteGraph" :label="$t('btn.delete')"
                        class="m-1" v-if="compositor && id" />
                </div>
                <Chart type="bar" :data="data" :options="graphOptions"
                    :class="{ 'col-6': compositor, 'col-12': !compositor }" />

                <div v-if="compositor" class="col-3 field">
                    <label>{{ $t('DemurrageStatistics.bars') }}</label>
                    <Listbox v-model="barSelectedColumns" :options="allColumns" optionLabel="label" class="w-full"
                        multiple>
                        <template #option="slotProps">
                            <div>{{ $t(slotProps.option.columnLabel) }}</div>
                        </template>
                    </Listbox>
                </div>
                <div v-if="compositor" class="col-3 field">
                    <label>{{ $t('DemurrageStatistics.lines') }}</label>
                    <Listbox v-model="lineSelectedColumns" :options="allColumns" optionLabel="columnLabel"
                        class="w-full" multiple>
                        <template #option="slotProps">
                            <div>{{ $t(slotProps.option.columnLabel) }}</div>
                        </template>
                    </Listbox>
                </div>
            </div>

        </template>
    </Card>
</template>